import { Revert } from "@wix/wix-ui-icons-common";
import React, { useContext } from "react";
import { EditorContext, RicosContext } from "./../../ricos-context/index.js";
import { ToolbarButton } from "./../../_shared/toolbar-button/toolbar-button.js";
import { useVerticalEmbedRequestService } from "../services/fetchVerticalEmbedData.js";
import { VERTICAL_EMBED_TYPE } from "../types.js";
import { getLowerCaseAppEmbedType, isTypeAppEmbed, toAppEmbedData } from "../utils.js";
const UpdateInformationButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  const { getPublicCommands } = useContext(EditorContext);
  const { fetchVerticalEmbedItem } = useVerticalEmbedRequestService();
  const handleClick = async () => {
    const publicCommands = getPublicCommands();
    const selectedNode = toolbarItem.attributes?.selectedNode;
    const attrs = selectedNode?.attrs;
    const nodeId = attrs?.id;
    const type = attrs?.type;
    const itemId = attrs?.itemId;
    if (!publicCommands || !nodeId || !itemId || !isTypeAppEmbed(type)) {
      return;
    }
    const verticalApiType = getLowerCaseAppEmbedType(type);
    publicCommands.setBlock(nodeId, VERTICAL_EMBED_TYPE, {
      ...attrs,
      loading: true,
      error: false
    });
    try {
      const updatedItem = await fetchVerticalEmbedItem(verticalApiType, itemId);
      if (updatedItem) {
        const updatedEmbedData = toAppEmbedData(updatedItem, attrs, t);
        publicCommands.setBlock(nodeId, VERTICAL_EMBED_TYPE, {
          ...updatedEmbedData,
          error: false,
          loading: false
        });
      } else {
        publicCommands.setBlock(nodeId, VERTICAL_EMBED_TYPE, {
          ...attrs,
          loading: false
        });
      }
    } catch (e) {
      const error = e instanceof Error && e.status === 404 ? "NOT_FOUND" : "FAILED";
      publicCommands.setBlock(nodeId, VERTICAL_EMBED_TYPE, {
        ...attrs,
        loading: false,
        error
      });
    }
  };
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      prefix: Revert,
      onClick: handleClick,
      dataHook,
      tooltip: t("Embed_Vertical_UpdateInformation_Tooltip")
    }
  );
};
export {
  UpdateInformationButton
};
//# sourceMappingURL=UpdateInformationButton.js.map
